import React from "react";
import { Paper, Card, CardContent, Typography, withStyles } from "@material-ui/core";
import MaterialTable from "material-table";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import RefreshIcon from "@material-ui/icons/Refresh";
import exchangeRates from "../../service/exchangeRates";
import { getTenant } from "../../libs/tenant";
import RateDialog from "./RateDialog";
import ConfirmDialog from "../alertas/Confirm";
import SuccessAlert from "../alertas/SuccessAlert";
import { TERM_FIELDS, TERM_LABELS, formatRate, formatDate } from "./terms";

// Histórico de cotações + destaque da cotação vigente (a que o app está mostrando).
// Props: enterpriseId.
class RateList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { title: "id", field: "id", hidden: true },
        {
          title: "Data",
          field: "quote_date",
          render: (row) => formatDate(row.quote_date),
        },
        {
          title: "Par",
          field: "base_currency",
          render: (row) => `${row.base_currency}/${row.quote_currency}`,
        },
        ...TERM_FIELDS.map((field) => ({
          title: TERM_LABELS[field],
          field,
          render: (row) => formatRate(row[field]),
        })),
        { title: "Observação", field: "notes" },
      ],
      data: [],
      latest: null,
      loading: false,
      openDialog: false,
      editingRate: null,
      confirmDelete: null,
      successMessage: "",
    };
  }

  componentDidMount() {
    this.load();
  }

  load = () => {
    this.setState({ loading: true });
    const domain = getTenant();
    Promise.all([
      exchangeRates.list(domain, { limit: 90 }),
      exchangeRates.latest(domain),
    ])
      .then(([data, latest]) =>
        this.setState({ data: data || [], latest: latest || null, loading: false })
      )
      .catch(() => this.setState({ loading: false }));
  };

  handleSaveDialog = (message) => {
    this.setState({ openDialog: false, editingRate: null, successMessage: message });
    this.load();
  };

  deleteRate = () => {
    const rate = this.state.confirmDelete;
    exchangeRates.remove(rate.id).then(() => {
      this.setState({ confirmDelete: null, successMessage: "Cotação removida." });
      this.load();
    });
  };

  render() {
    const { classes } = this.props;
    const { latest } = this.state;

    return (
      <Paper>
        {this.state.openDialog && (
          <RateDialog
            enterpriseId={this.props.enterpriseId}
            rate={this.state.editingRate}
            close={() => this.setState({ openDialog: false, editingRate: null })}
            save={() =>
              this.handleSaveDialog(
                this.state.editingRate ? "Cotação atualizada." : "Cotação publicada."
              )
            }
          />
        )}
        {this.state.confirmDelete && (
          <ConfirmDialog
            title="Atenção"
            body={`Deseja remover a cotação de ${formatDate(
              this.state.confirmDelete.quote_date
            )}?`}
            handleCloseConfirmT={this.deleteRate}
            handleCloseConfirmF={() => this.setState({ confirmDelete: null })}
          />
        )}
        <SuccessAlert
          open={!!this.state.successMessage}
          message={this.state.successMessage}
          onClose={() => this.setState({ successMessage: "" })}
        />

        {/* O que os vendedores estão vendo no app agora. Fica em destaque porque é
            a pergunta que o escritório faz todo dia ("já publiquei a de hoje?"). */}
        <Card className={classes.currentCard}>
          <CardContent>
            <Typography variant="subtitle2" color="textSecondary">
              Cotação vigente no app
            </Typography>
            {latest ? (
              <>
                <Typography variant="h6" className={classes.currentDate}>
                  {formatDate(latest.quote_date)} — {latest.base_currency}/
                  {latest.quote_currency}
                </Typography>
                <div className={classes.termsRow}>
                  {TERM_FIELDS.map((field) => (
                    <div key={field} className={classes.term}>
                      <Typography variant="caption" color="textSecondary">
                        {TERM_LABELS[field]}
                      </Typography>
                      <Typography variant="h6">
                        {formatRate(latest[field])}
                      </Typography>
                    </div>
                  ))}
                </div>
                {latest.notes && (
                  <Typography variant="body2" color="textSecondary">
                    {latest.notes}
                  </Typography>
                )}
              </>
            ) : (
              <Typography variant="body2" color="textSecondary">
                Nenhuma cotação publicada ainda.
              </Typography>
            )}
          </CardContent>
        </Card>

        <MaterialTable
          title="Histórico de cotações"
          columns={this.state.columns}
          data={this.state.data}
          isLoading={this.state.loading}
          options={{ search: true, actionsColumnIndex: -1, pageSize: 10 }}
          actions={[
            {
              icon: () => <AddIcon />,
              tooltip: "Publicar cotação",
              isFreeAction: true,
              onClick: () => this.setState({ openDialog: true, editingRate: null }),
            },
            {
              icon: () => <RefreshIcon />,
              tooltip: "Atualizar",
              isFreeAction: true,
              onClick: () => this.load(),
            },
            {
              icon: () => <EditIcon />,
              tooltip: "Editar",
              onClick: (event, row) =>
                this.setState({ openDialog: true, editingRate: row }),
            },
            {
              icon: () => <DeleteIcon />,
              tooltip: "Remover",
              onClick: (event, row) => this.setState({ confirmDelete: row }),
            },
          ]}
        />
      </Paper>
    );
  }
}

const styles = (theme) => ({
  currentCard: {
    margin: theme.spacing(2),
  },
  currentDate: {
    marginBottom: theme.spacing(1),
  },
  termsRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
  term: {
    minWidth: 120,
  },
});

export default withStyles(styles)(RateList);
